import {AbstractControl} from "@angular/forms";
import {_codiceFiscalePiva, codiceFiscale, formatoData, formatoEmail, formatoName, formatoSwift, iban, partitaIva, passwordPattern, phoneNumberPattern} from "../models/validators.model";

export function ValidateMail(control: AbstractControl) {
	if (formatoEmail.test(control.value)) {
		return null;
	}

	return {invalidMail: true};
}

export function ValidateDate(control: AbstractControl) {
	if (new Date().getTime() < control.value) {
		return {invalidDate: true};
	}

	return null;
}

export function ValidateName(control: AbstractControl) {
	if (formatoName.test(control.value)) {
		return null;
	}

	return {invalidName: true};
}

export function ValidatePassword(control: AbstractControl) {
	if (passwordPattern.test(control.value)) {
		return null;
	}

	return {invalidPassword: true};
}

export function ValidateIban(control: AbstractControl) {
	if (iban.test(control.value)) {
		return null;
	}

	return {invalidIban: true};
}

export function ValidazioneData(control: AbstractControl) {
	if (formatoData.test(control.value)) {
		return null;
	}

	return {invalidFormatDate: true};
}

export function ValidateCodiceFiscale(control: AbstractControl) {
	if (codiceFiscale.test(control.value)) {
		return null;
	}

	return {codiceFiscaleInvalido: true};
}

export function ValidateCodiceFiscalePIVA(control: AbstractControl) {
	if (_codiceFiscalePiva.test(control.value) && control.value?.length >= 11) {
		return null;
	}

	return {cfInvalidoFormalmente: true};
}

export function ValidatePartitaIva(control: AbstractControl) {
	if (partitaIva.test(control.value)) {
		return null;
	}

	return {cfInvalidoFormalmente: true};
}

export function ValidateImportoFormato(valoreImporto: string): boolean {
	return /^[0-9]*,[0-9]{2}$/.test(valoreImporto);
}

export function ValidatoreSwift(control: AbstractControl) {
	if (formatoSwift.test(control.value)) {
		return null;
	}
	return {invalidSwift: true};
}

export function ValidatePhone(control: AbstractControl) {
	if (!control.value || phoneNumberPattern.test(control.value)) {
		return null;
	}

	return {pattern: true};
}

